import { ColorVariant, Pagination } from '@makyoapp/makyo-tw-ui'

export interface CompPaginationProps {
  totalPages: number
  page: number
  perPage: number
  onChange(page: number, perPage: number): void
  backgroundColor?: ColorVariant
}

/**
 * CompPagination
 *
 * @note the page received usually starts from 0, but the pagination component will start from 1
 */
export const CompPagination = ({
  totalPages,
  page,
  perPage,
  onChange,
  backgroundColor = 'primary-95',
}: CompPaginationProps) => {
  return (
    <Pagination
      className='w-auto'
      totalPages={totalPages}
      currentPage={page + 1}
      onPageChange={(page) => onChange(page - 1, perPage)}
      previousLabel=''
      nextLabel=''
      pageBackgroundColor={backgroundColor}
      cornerRadius='full'
    />
  )
}
